import axios from 'axios';
import config from '../../../../config';
import * as utils from '../../../../utils/common';
let getDateFormats = function () {
    return new Promise(async (resolve, reject) => {
        axios
            .get(`${config.api.urlHost}${config.api.basePath}/client/dateFormats`, {
                headers: { token: utils.getAPIToken() }
            })
            .then((dateFormatsDataArray) => {
                resolve(dateFormatsDataArray);
            })
            .catch((err) => {
                console.log('### err-', err);
                reject(err);
            });
    });
};

let changeDateFormatId = function (dateFormatId) {
    return new Promise(async (resolve, reject) => {
        // console.log('###-dateFormatId-', dateFormatId);

        axios
            .patch(
                `${config.api.urlHost}${config.api.basePath}/client/dateFormats/dateFormatId/${dateFormatId}`,
                { reqData: null },
                {
                    headers: { token: utils.getAPIToken() }
                }
            )
            .then((responseData) => {
                resolve(responseData);
            })
            .catch((err) => {
                console.log('### err-', err);
                reject(err);
            });
    });
};

let changeCompanyName = function (values) {
    return new Promise(async (resolve, reject) => {
        axios
            .post(
                `${utils.getServerURL()}/client/changeClientName`,
                { reqData: values },
                {
                    headers: { token: utils.getAPIToken() }
                }
            )
            .then((responseData) => {
                resolve(responseData);
            })
            .catch((err) => {
                console.log('### err-', err);
                reject(err);
            });
    });
};

let changeAppConfigByConfigKeyAndConfigValue = function (configKey, configValue) {
    return new Promise(async (resolve, reject) => {
        // console.log('####-configKey-', configKey);
        // console.log('####-configValue-', configValue);

        axios
            .put(
                `${utils.getServerURL()}/modbus/appConfig/${configKey}/${configValue}`,
                {},
                {
                    headers: { token: utils.getAPIToken() }
                }
            )
            .then((responseData) => {
                resolve(responseData);
            })
            .catch((err) => {
                console.log('### err-', err);
                reject(err);
            });
    });
};

let getAppConfigByConfigKey = function (configKey) {
    return new Promise(async (resolve, reject) => {
        axios
            .get(`${utils.getServerURL()}/modbus/appConfig/${configKey}`, {
                headers: { token: utils.getAPIToken() }
            })
            .then((resData) => {
                resolve(resData);
            })
            .catch((err) => {
                console.log('### err-', err);
                reject(err);
            });
    });
};

export default { getDateFormats, changeDateFormatId, changeCompanyName, changeAppConfigByConfigKeyAndConfigValue, getAppConfigByConfigKey };
